export default {
  evaluation: {
    common: {
      save: '保存',
      cancel: '取消',
    },
    enums: {
      evalSetStatus: {
        draft: '草稿',
        active: '生效中',
      },
      evalSetMode: {
        'single-turn': '单轮',
        'multi-turn': '多轮',
      },
      evalCaseType: {
        normal: '普通',
        boundary: '边界',
        exception: '异常',
      },
      experimentType: {
        regression: '标准实验',
        replay: '流量重放',
      },
      experimentStatus: {
        idle: '未开始',
        running: '执行中',
        completed: '已完成',
        failed: '已失败',
        gated: '门禁拦截',
      },
      caseRunStatus: {
        pass: '通过',
        fail: '失败',
        unknown: '未知',
      },
      failType: {
        natural: '系统失败',
        business: '业务不通过',
      },
      scoreSource: {
        rule: '规则评分',
        code: '代码评分',
        llm: 'LLM 评分（预留）',
        none: '无',
      },
      successPreset: {
        'default': '标准模式',
        'strict': '严格模式',
        'format-only': '格式校验',
        'custom': '自定义',
      },
      evalNodeType: {
        none: '规则评分（无评测节点）',
        code: 'JS 代码评分',
        llm: 'LLM 评分（预留）',
      },
    },
    hints: {
      lockedDataset: '该评测集已锁定，不可编辑',
      lockedReason: '锁定原因：{reason}',
      runningCannotDelete: '运行中的实验不可删除，请先终止',
      gatedOnlyContinue: '仅 gated 状态可继续执行',
      llmReserved: 'LLM 评分为预留功能，当前降级为规则评分',
      aiGenerateReserved: 'AI 生成用例为占位接口，结果不入库',
      multiTurnReserved: 'multi-turn 模式当前仅存储，执行时不区分轮次',
      replayReserved: '流量重放当前执行逻辑与标准实验相同',
      traceEmpty: '未开启工作流执行日志，无 trace 数据',
    },
    datasets: {
      list: {
        title: '评测集管理',
        create: '新建评测集',
        searchPlaceholder: '搜索评测集名称...',
        columns: {
          name: '名称',
          toolName: '关联工作流',
          mode: '模式',
          caseCount: '用例数',
          version: '版本',
          status: '状态',
          createdAt: '创建时间',
          createdBy: '创建人',
          action: '操作',
        },
        mode: {
          singleTurn: '单轮评测',
          multiTurn: '多轮评测',
        },
        status: {
          active: '生效中',
          draft: '草稿',
        },
        action: {
          detail: '详情',
          delete: '删除',
        },
        deleteConfirm: '确定删除该评测集吗？删除后无法恢复。',
        deleteSuccess: '评测集已删除',
        deleteFailed: '删除失败，请稍后重试',
        loadFailed: '加载评测集列表失败',
      },
      create: {
        name: '评测集名称',
        namePlaceholder: '请输入评测集名称',
        toolName: '关联工作流',
        toolNamePlaceholder: '请选择工作流（可选）',
        toolVersion: '关联版本',
        toolVersionPlaceholder: '请先选择工作流',
        mode: '对话模式',
        description: '描述',
        descriptionPlaceholder: '请输入评测集描述（可选）',
        success: '评测集创建成功',
        failed: '评测集创建失败',
        nameRequired: '请输入评测集名称',
        toolNameRequired: '请选择工作流',
        toolVersionRequired: '请选择工作流版本',
      },
      detail: {
        title: '评测集详情',
        editInfo: '编辑信息',
        editInfoSuccess: '信息更新成功',
        editInfoFailed: '更新失败',
        tabs: {
          cases: '用例列表',
          coverage: '覆盖度分析',
          history: '版本历史',
        },
        cases: {
          add: '添加用例',
          import: '批量导入',
          aiGenerate: 'AI 生成',
          edit: '编辑',
          duplicate: '复制',
          editSuccess: '用例已更新',
          editFailed: '更新用例失败',
          duplicateSuccess: '用例已复制',
          duplicateFailed: '复制用例失败',
          turns: '对话轮次',
          addTurn: '添加轮次',
          turnSummary: '{count} 轮',
          turnIndex: '轮次 {index}',
          turnUser: '用户',
          turnAssistant: '助手',
          turnUserPlaceholder: '用户消息...',
          turnAssistantPlaceholder: '助手回复...',
          turnExpectedScore: '期望评分',
          emptyContent: '(空)',
          columns: {
            input: '输入 (Input)',
            referenceOutput: '参考输出 (Reference)',
            type: '类型',
            note: '补充说明',
            action: '操作',
          },
          notePlaceholder: '可选，填写该用例的补充说明',
          deleteConfirm: '确定删除该用例吗？',
          deleteSuccess: '用例已删除',
          deleteFailed: '删除用例失败',
          batchDelete: '批量删除',
          batchDeleteConfirm: '确定删除所选的 {count} 个用例吗？',
          batchDeleteSuccess: '已删除 {count} 个用例',
          batchDeleteFailed: '批量删除失败',
          addSuccess: '用例添加成功',
          addFailed: '添加用例失败',
          required: '请填写输入和参考输出',
          multiTurnRequired: '请填写用例标签及至少一轮对话内容',
          aiGenerateModal: {
            title: 'AI 生成用例',
            configStep: '配置生成参数',
            previewStep: '预览生成结果',
            description: '场景描述',
            descriptionPlaceholder:
              '描述你希望生成的测试场景，如"客服常见问题"',
            referenceDoc: '参考文档（选填）',
            referenceDocPlaceholder: '粘贴参考内容，AI 将据此生成相关测试用例',
            count: '生成数量',
            typeDistribution: '用例类型分布',
            typeDistributionHint: '各类型数量之和须等于生成数量',
            normal: '正常用例',
            boundary: '边界用例',
            exception: '异常用例',
            llmConfig: 'LLM 配置',
            llmConfigPlaceholder: '默认模型',
            llmConfigTip: '选择用于生成用例的 LLM 配置，不选则使用系统默认模型',
            generate: '生成',
            generating: '生成中...',
            previewDesc: '共生成 {count} 条用例（预览），确认后将保存入库',
            previewMeta: '模型：{model}，消耗 Token：{tokens}',
            confirmSave: '确认保存',
            regenerate: '重新生成',
            saveSuccess: '成功保存 {count} 条用例',
            saveFailed: '保存失败，请重试',
            generateFailed: '生成失败，请重试',
            countRequired: '请填写生成数量',
            distributionMismatch: '分布数量之和须等于生成数量',
          },
        },
        coverage: {
          title: '覆盖度分析',
          normal: '正常',
          boundary: '边界',
          exception: '异常',
          balanced: '分布均衡',
          warning: '建议优化',
          insufficient: '覆盖不足',
          insufficientHint:
            '边界+异常用例占比不足 10%，建议补充以提高评测覆盖度',
          balancedHint: '用例分布均衡（正常 60±10%，边界/异常各 ≥10%）',
          empty: '暂无用例，添加后自动展示覆盖分析',
        },
        import: {
          title: '批量导入 JSON',
          confirmBtn: '导入',
          confirmBtnCount: '导入 {count} 条',
          placeholder:
            '粘贴 JSON，格式：\n{\'{\'}\n  "cases": [\n    {\'{\'} "input": "...", "expected_output": "...", "type": "normal" {\'}\'}\n  ]\n{\'}\'}',
          valid: '有效用例',
          invalid: '错误行',
          preview: '解析预览',
          success: '已成功导入 {imported} 条用例',
          failed: '导入失败',
          parseError: 'JSON 解析错误',
          noCases: '缺少 cases 数组',
          rowError: '第 {line} 行：{message}',
          inputRequired: 'input 字段不能为空',
          outputRequired: 'expectedOutput 字段不能为空',
          invalidType: 'type 必须为 normal / boundary / exception',
        },
        history: {
          columns: {
            version: '版本号',
            caseCount: '用例数',
            createdAt: '创建时间',
            action: '操作',
          },
        },
        empty: '暂无数据',
        loadFailed: '加载评测集详情失败',
        createVersion: '创建版本快照',
        createVersionSuccess: '版本 {version} 创建成功',
        createVersionFailed: '创建版本快照失败',
        unlock: '解锁',
        unlockSuccess: '评测集已解锁',
        unlockFailed: '解锁失败',
      },
    },
    experiments: {
      list: {
        title: '实验管理',
        create: '新建实验',
        typePlaceholder: '实验类型',
        allTypes: '全部类型',
        searchPlaceholder: '搜索实验名称...',
        columns: {
          name: '实验名称',
          type: '类型',
          workflow: '关联工作流',
          evalSet: '评测集',
          status: '状态',
          successRate: '成功率',
          duration: '耗时',
          createdBy: '创建人',
          action: '操作',
        },
        type: {
          regression: '标准实验',
          replay: '流量重放',
        },
        status: {
          idle: '未开始',
          running: '执行中',
          completed: '已完成',
          failed: '已失败',
          gated: '门禁拦截',
        },
        action: {
          detail: '详情',
          delete: '删除',
        },
        deleteConfirm: '确定删除该实验吗？删除后无法恢复。',
        deleteSuccess: '实验已删除',
        deleteFailed: '删除失败，请稍后重试',
        loadFailed: '加载实验列表失败',
      },
      create: {
        name: '实验名称',
        namePlaceholder: '请输入实验名称',
        type: '实验类型',
        typeRegression: '标准实验（回归）',
        typeReplay: '流量重放',
        typeReplayTip: '从历史执行日志中抓取真实 input 重放，无需手动编写用例',
        evalSetId: '评测集',
        evalSetIdPlaceholder: '选择评测集',
        evalSetIdReplayTip:
          '流量重放模式下可不选评测集（用例来自 workflow 执行日志）',
        toolName: '工作流',
        toolNamePlaceholder: '选择工作流',
        replayConfig: {
          title: '流量重放配置',
          sourceWorkflow: '来源 Workflow',
          sourceWorkflowTip: '从哪个 workflow 的执行日志抓取历史 input',
          sourceWorkflowPlaceholder: '选择来源 workflow',
          startTime: '开始时间',
          startTimePlaceholder: '不限',
          endTime: '结束时间',
          endTimePlaceholder: '不限',
          maxCases: '最多重放条数',
          maxCasesPlaceholder: '默认 100',
          sourceEnv: '数据源环境',
          sourceEnvPlaceholder: '不限',
          sourceEnvProd: '生产环境 (prod)',
          sourceEnvStaging: '预发环境 (staging)',
        },
        llmConfig: 'LLM 配置',
        llmConfigTip:
          '选择用于实验评分（内置规则评分、LLM 评测节点等所有 LLM 调用）的模型配置，优先级高于评测节点内的配置，不选则使用系统默认',
        llmConfigPlaceholder: '选择模型配置（可选）',
        preset: '成功标准预设',
        presetTip:
          'default：min_score=0.6；strict：min_score=0.8 + JSON 格式校验；format-only：min_score=0，只检查格式；custom：用户自定义，可配置评测节点',
        criteria: {
          title: '自定义评分标准',
          minScore: '最低通过分',
          minScoreTip: '单条用例得分 ≥ 该值视为通过（0~1）',
          minScorePlaceholder: '0~1，如 0.6',
          requireJsonFormat: '要求输出 JSON 格式',
          requireJsonFormatTip:
            '开启后，工作流输出无法解析为合法 JSON 时，该用例直接判失败',
          requiredFields: '必含字段（逗号分隔）',
          requiredFieldsTip: '输出 JSON 中必须包含这些 key，缺少任一则扣分',
          requiredFieldsPlaceholder: '如 answer,score',
          forbiddenPatterns: '禁止模式（逗号分隔）',
          forbiddenPatternsTip: '输出文本中出现任一关键词则判为失败',
          forbiddenPatternsPlaceholder: '如 error,sorry',
          maxLatency: '最大延迟（ms）',
          maxLatencyTip:
            '单条用例执行耗时超过此值（毫秒）则判为失败，0 表示不限制',
          maxLatencyPlaceholder: '0 表示不限制，如 5000',
          maxLatencyNoLimit: '不限制',
          gateThreshold: '门禁失败率阈值',
          gateThresholdTip:
            '实时失败率超过此值时自动暂停（状态→gated）。设为 0 表示不启用门禁',
          gateThresholdPlaceholder: '0~1，0 表示不启用',
          gateMinCases: '门禁最少执行数',
          gateMinCasesTip:
            '至少执行该数量的用例后才开始检查门禁，避免样本太少误触发',
          gateMinCasesPlaceholder: '至少执行多少条后检查',
        },
        evalNode: {
          title: '评测节点',
          type: '评测方式',
          typeTip:
            'none：内置规则评分；code：自定义 JS 脚本；llm：LLM 评分（调用大模型评测）',
          codeScript: '评分脚本',
          codeScriptTip:
            '脚本可访问：input（用例输入）、expected（参考输出）、actual（工作流实际输出），需 return { score: 0~1, reason: string }',
          codeLanguage: '脚本语言',
          codeLanguagePlaceholder: '选择脚本语言',
          codeLanguageJavaScript: 'JavaScript',
          codeLanguagePython: 'Python',
          codeScriptPlaceholder:
            '// 脚本接收 input / expected / actual 变量\n// 返回 { score: number, reason: string }\nvar exp = JSON.parse(expected);\nvar act = JSON.parse(actual);\nif (act.answer === exp.answer) return {score:1, reason:"match"};\nreturn {score:0, reason:"mismatch"};',
          codeScriptGenerate: 'AI 生成脚本',
          codeScriptGenerateDesc: '描述评分逻辑，AI 将生成 JavaScript 评分脚本',
          codeScriptGeneratePlaceholder:
            '如：检查 JSON 格式，answer 字段不为空，且不包含敏感词',
          codeScriptGenerateSuccess: '脚本已生成',
          codeScriptGenerateFailed: '生成脚本失败',
          llmPrompt: 'LLM 评测 Prompt',
          llmPromptTip:
            '描述评测标准，系统会自动将 input/expected/actual 注入 prompt，使用 LLM 给出 0~1 的评分',
          llmPromptPlaceholder:
            '如：评估回答的准确性和完整性，准确回答得 0.8+，部分正确 0.4-0.7...',
          llmPromptGenerate: 'AI 生成 Prompt',
          llmPromptGenerateDesc: '描述评测标准，AI 将生成 LLM 评测 Prompt',
          llmPromptGeneratePlaceholder:
            '如：评估客服回答的专业性、准确性和友好度',
          llmPromptGenerateSuccess: 'Prompt 已生成',
          llmPromptGenerateFailed: '生成 Prompt 失败',
          llmConfig: 'LLM 配置',
          llmConfigTip: '选择用于评测的 LLM 配置，不选则使用系统默认模型',
          llmConfigPlaceholder: '默认模型',
        },
        workflowVersion: '工作流版本',
        workflowVersionPlaceholder: '选择版本',
        required: '请填写实验名称并选择评测集和工作流',
        success: '实验创建成功',
        failed: '实验创建失败',
      },
      detail: {
        title: '实验详情',
        run: '开始跑批',
        rerun: '重新跑批',
        stop: '终止实验',
        continue: '继续执行',
        edit: '编辑实验',
        editSuccess: '实验已更新',
        editFailed: '更新失败，请稍后重试',
        editDisabledHint: '运行中的实验不可编辑',
        delete: '删除实验',
        deleteConfirm: '确定删除该实验吗？删除后无法恢复。',
        deleteSuccess: '实验已删除',
        deleteFailed: '删除失败，请稍后重试',
        loadFailed: '加载实验详情失败',
        runSuccess: '实验已启动',
        runFailed: '启动实验失败',
        stopSuccess: '实验已终止',
        stopFailed: '终止失败',
        continueSuccess: '实验继续执行',
        continueFailed: '继续执行失败',
        tabs: {
          config: '实验配置',
          results: '执行结果',
          analysis: '对撞分析',
        },
        config: {
          title: '成功标准配置',
          preset: '预设模式',
          evalNode: '评测节点',
          workflowVersion: '工作流版本',
          mode: {
            default: '标准模式',
            strict: '严格模式',
            formatOnly: '格式校验',
            custom: '自定义',
          },
          nodeType: {
            none: '无 (内置规则评分)',
            llm: 'LLM 评测',
            code: 'JS 代码评分',
          },
        },
        results: {
          failureRate: '失败率',
          naturalFailureCount: '自然失败',
          businessFailureCount: '业务失败',
          avgLatency: '平均耗时',
          avgToken: '平均 Token',
          errorRate: '异常率',
          loadFailed: '加载结果列表失败',
          loadDetailFailed: '加载结果详情失败',
          runningProgress: '执行中：{done} / {total} 个用例已完成',
          gatedHint: '门禁触发：成功率低于阈值，实验已暂停。可继续执行或终止。',
          traceTitle: '执行链路 (Trace)',
          filter: {
            status: '结果状态',
            failType: '失败类型',
            caseType: '用例类型',
            keyword: '搜索输入',
            all: '全部',
          },
          columns: {
            caseId: '用例 ID',
            input: '输入',
            expected: '参考输出',
            actual: '实际输出',
            status: '状态',
            score: '评分',
            scoreSource: '评分来源',
            failType: '失败类型',
            latency: '耗时(ms)',
            action: '操作',
          },
          viewDetail: '详情',
        },
        resultDetail: {
          title: '结果详情',
          input: '输入',
          expected: '参考输出',
          actual: '实际输出',
          score: '评分',
          status: '状态',
          scoreSource: '评分来源',
          failType: '失败类型',
          failReason: '失败原因',
          llmReason: 'LLM 评分理由',
          llmModel: '评分模型',
          evalResult: '评分详情',
          trace: 'Trace',
          traceEmpty: '未开启工作流执行日志，无 trace 数据',
          loadFailed: '加载结果详情失败',
        },
        analysis: {
          empty: '暂无对比数据',
        },
      },
    },
    cost: {
      title: '成本治理',
      selectWorkflow: '选择工作流',
      allWorkflows: '全部工作流',
      stats: {
        totalCost: '总成本 (USD)',
        totalTokens: '总 Token 消耗',
        avgDailyCost: '日均成本 (USD)',
      },
      columns: {
        workflowName: '工作流名称',
        calls: '调用次数',
        tokens: '总 Token',
        cost: '预估成本 (USD)',
        action: '操作',
      },
      action: {
        replay: '流量重放',
      },
    },
  },
};
